import { array } from "@msuite/utils/array";
import { moment } from "@msuite/utils/date";
import { randomNumber } from "@msuite/utils/numbers";

const min = -100;
const max = 500;

export function getBarChartData(items: number) {
	return array(items, (index) => ({
		name: moment().add(index, "days").format("dd"),
		uv: randomNumber(min, max),
		pv: randomNumber(min, max, false),
		mx: randomNumber(min, max),
	}));
}
